// Taille maximale des pièces jointes d'un e-mail (9,5 Mo) — repli si l'API ne renvoie pas la valeur.
export const MAX_EMAIL_ATTACHMENT_SIZE = 9961472

// Formate une taille en octets de façon lisible (o / Ko / Mo).
export function formatFileSize(bytes: number | null | undefined): string {
     if (bytes == null) return ""
     if (bytes < 1024) return `${bytes} o`
     if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} Ko`
     return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`
}

// Déclenche le téléchargement d'un blob (ex : ZIP renvoyé par l'API) sous le nom de fichier donné.
export function triggerBlobDownload(data: Blob, filename: string, mimeType = "application/zip") {
     const url = URL.createObjectURL(new Blob([data], { type: mimeType }))
     const link = document.createElement("a")
     link.href = url
     link.download = filename
     document.body.appendChild(link)
     link.click()
     link.remove()
     URL.revokeObjectURL(url)
}
